import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { RelativeOrientation } from '../../types';

interface INfdReadingProps extends IWorksheetComponent {
  heading?: string;
  readingNo?: number;
}

const Component: React.FC<INfdReadingProps> = ({ heading, readingNo }) => {
  return (
    <SectionGroup heading={heading}>
      {readingNo && readingNo > 1 && (
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            label="Orientation Relative to Original Reading"
            name="RelativeOrientation"
            options={[
              { label: '180°', value: RelativeOrientation.StraightAngle },
              { label: 'Horizontally Adjacent', value: RelativeOrientation.HorizontallyAdjacent },
              { label: 'Vertically Adjacent', value: RelativeOrientation.VerticallyAdjacent },
            ]}
          />
        </ListFieldSection>
      )}
      <ListFieldSection>
        <Field input={<NumericInput />} label="Bulk Density" name="WetDensity" />
        <Field input={<NumericInput />} label="Moisture Density" name="MoistureDensity" />
        <Field input={<TextOutput />} label="Corrected Bulk Density" name="WetDensityMeasured" />
        <Field input={<TextOutput />} label="Corrected Moisture Density" name="MoistureDensityMeasured" />
        <Field input={<TextOutput />} label="Corrected Gauge Moisture Content (%)" name="MoistureContentMeasured" />
        <Field input={<TextOutput />} label="Gauge Dry Density" name="DryDensity" />
      </ListFieldSection>
    </SectionGroup>
  );
};

const BsNfdReading = withInjectedProps(Component);

export { BsNfdReading };
export default BsNfdReading;
